export default __webpack_public_path__ + "static/media/intermediate-home.44393e30.svg";